import styled from '@emotion/styled'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 4px;
`
export const Title = styled.div`
  font-weight: bold;
  font-size: 16px;
  align-self: center;
  margin: 8px;
`

export const LastKnownLocationBanner = styled.div`
  font-weight: bold;
  font-size: 16px;
  align-self: center;
  margin: 8px;
  background-color: #ffdd00;
  padding: 5px 10px 5px 10px;
  width: 100%;
`

export const Table = styled.div`
  display: table;
`

export const Row = styled.div`
  display: flex;
  font-family: 'Open Sans', sans-serif;
  display: table-row;
`

export const Label = styled.div`
  display: table-cell;
  padding: 4px;
`

export const Value = styled.div`
  font-weight: bold;
  display: table-cell;
`
